import { z } from 'zod';

export enum ChartType {
  VOLTAGE = 'Voltage',
  CURRENT = 'Current',
  VOLTAGE_AC = 'Voltage AC',
  CURRENT_AC = 'Current AC',
  SOC = 'SOC',
  TEMPERATURE = 'Temperature',
  CELL_VOLTAGE = 'Cell Voltage',
  POWER = 'Power',
  POWER_FACTOR = 'Power Factor',
  ENERGY = 'Energy',
  FREQUENCY = 'Frequency',
  UNITS_ONLINE = 'Units Online',
  RACKS_ONLINE = 'Racks Online',
  HS_CONTROL_AGC = 'HS Control AGC',
}

export const ChartTypeSchema = z.nativeEnum(ChartType);
